package gr.tech.site.models

data class PodcastEntry(
    val title: String,
    val thumbnailId: String,
    val link: String,
    val desc: String,
    val date: String, // format: "YYYY-MM-DD"
)

